export const helpUrlBase = "http://help.gerpgo.com/web/#/26?page_id=";

//路由名称去掉‘-’作为键名，文档id作为键值
//路由名不可重复
export const helpUrls = {
    // 主页-------------------------------------------------------
    // dashboard
    dashboard: '564',
    //海卖助手
    sellerassistant: '646',

    // 产品-------------------------------------------------------
    // 产品管理-产品资料
    productmanager: '565',
    // 产品管理-品牌资料
    productbrand: '566',
    // 产品管理-品类资料
    productcategory: '567',

    // 销售-------------------------------------------------------
    // 商品-listing
    listing: '568',
    // 商品-review
    review: '611',
    // 商品-feedback
    feedback: '612',
    // 商品-运营日志
    operationlog: '647',
    // 订单-销售订单
    saleOrder: '569',
    // 订单-推广订单
    promoteOrder: '571',
    // 数据报告-退货报告
    customerReturn: '595',
    // 数据报告-换货报告
    replacementOrder: '648',
    // 数据报告-配送报告
    amazonShipment: '594',
    // 数据报告-移除报告
    removalShipment: '596',

    // 采购-------------------------------------------------------
    // 采购管理-采购计划
    purchaseplan: '770',
    // 采购管理-采购订单
    purchaseorder: '695',
    // 采购管理-交货单
    deliveryorder: '696',
    // 采购管理-采购变更单
    purchaseorderchange: '697',
    // 基础配置-供应商资料
    suppliermanager: '694',

    // 仓库-------------------------------------------------------
    // 库存管理-产品库存
    productinventory: '698',
    // 库存管理-FBA库存
    fbainventory: '573',
    // 库存管理-仓库库存
    warehouseinventory: '572',
    // 库存操作-采购入库单
    inboundorder: '699',
    // 库存操作-调拨单
    transferorder: '700',
    // 库存操作-装配单
    assemblyorder: '701',
    // 库存操作-盘点单
    inventorycheck: '702',
    // 库存操作-出入库记录
    inboundoutbound: '703',
    // 库存操作-成本补录
    costsupplement: '743',
    // 基础配置-仓库资料
    warehouseinformation: '575',

    // 物流-------------------------------------------------------
    // 发货管理-发货计划
    deliveryPlan: '779',
    // 发货管理-FBA货件
    fbashipment: '599',
    // 发货管理-发货单
    shipmentbill: '704',
    // 基础配置-头程物流
    headlogistics: '1222',
    // 基础配置-物流商资料
    logisticsprovider: '705',

    // 广告-------------------------------------------------------
    // 广告管理-商品广告
    spadmanager: '576',
    // 广告管理-展示广告
    sdadmanager: '577',
    // 广告管理-品牌广告
    sbadmanager: '578',
    // 广告工具-分时策略
    timeadjuststrategy: '643',
    // 广告工具-调整日志
    strategyadjustlog: '644',
    // 广告工具-关键词排名
    keywordrank: '728',
    // 广告分析-Asin分析
    asinanalysis: '579',
    // 广告分析-热词分析
    keywordanalysis: '580',
    // 广告分析-搜索词分析
    searchwordanalysis: '581',

    // 客服-------------------------------------------------------
    // 品控-标签管理
    tagmanager: '600',
    // 客户邮件-邮件回复
    mailreplymanager: '636',
    // 客户邮件-邮件模板
    mailtemplate: '637',
    // Request&Review-请求规则
    sendrule: '1361',
    // Request&Review-请求记录
    sendrecord: '761',

    // 财务-------------------------------------------------------
    // 财务报表-利润报告
    financeprofitreport: '584',
    // 财务报表-回款报告
    remittancerecord: '586',
    // 财务报表-业绩报告
    performancereport: '759',
    // 成本管理-成本中心
    costcenter: '585',
    // 成本管理-扣减记录
    deductionrecord: '753',
    // 成本管理-批次管理
    batchmanagement: '755',

    // 分析-------------------------------------------------------
    // 运营分析-全店铺看板
    shopwideanalysis: '1189',
    // 运营分析-ASIN看板
    asin361analysis: '1190',
    // 销售分析-商品表现
    listinganalysis: '1191',
    // 销售分析-商品统计
    listingstatistics: '1192',
    // 销售分析-产品表现
    productanalysis: '1193',
    // 销售分析-店铺表现
    marketanalysis: '1194',
    // 销售分析-店铺统计
    marketstatistics: '1195',
    // 销售分析-利润统计
    profitstatistics: '1196',
    // 亚马逊报表-赔偿
    compensate: '730',
    // 亚马逊报表-盘库
    inventoryadjustments: '750',
    // 亚马逊报表-月度仓储费
    monthlystoragecharge: '747',
    // 亚马逊报表-长期仓储费
    storagelongfee: '749',
    // 亚马逊报表-已接收库存
    receivedinve: '974',
    // 亚马逊报表-库存动作详情
    inveactiondetails: '973',
    // 亚马逊报表-FBA补货
    fbareplenishment: '593',
    // 绩效-全店铺绩效
    storeperformance: '731',
    // 绩效-单店铺绩效
    storeperformancedetails: '740',

    // 工具-------------------------------------------------------
    // 运营工具-跟卖监控
    followupmonitoring: '711',
    // 运营工具-索赔助手
    claim: '649',
    // 积加云助手-在线状态
    cloudpluginstatus: '603',
    // 积加云助手-报表记录
    cloudpluginreport: '604',

    // 系统-------------------------------------------------------
    // 权限管理-用户管理
    user: '597',
    // 权限管理-角色管理
    role: '598',
    // 基础信息-汇率管理
    exchangerate: '601',
    // 店铺管理-店铺授权
    market: '602',
    // 设置-参数设置
    argument: '629',
    // Vat管理
    vatmanage: '1399',
//    消息中心
    messagecenter: '1052'
};
